function handleHomeHeroVimeo() {
    const el = document.querySelector('.background-video');
    if (!el) return;
    let film = false;
    const filmId = el.dataset.vimeo;
    if (filmId) {
        film = new Vimeo.Player(el, {
            id: filmId,
            background: true,
        });
    }
}


function plyrVideoInit() {

    // if (document.querySelector('.video-plyr .video-inner video')) { // if HTML5 video
    //     const videoPlayer = new Plyr('.video-plyr .video-inner video', {
    //         controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
    //     });
    // } else { // Youtube or Vimeo
    //     const videoPlayer = new Plyr('.video-plyr .video-inner', {
    //         // volume: 0.1,
    //         controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
    //         // autoplay: true,
    //         // muted: true,
    //         // resetOnEnd: true,
    //
    //     });
    // }

    // const players = Plyr.setup('.video-plyr .video-inner', {
    //     // volume: 0.1,
    //     // controls: ['play', 'mute', 'volume'],
    //     autoplay: true,
    //     // muted: true,
    //     // resetOnEnd: true,
    // });

    // const players = new Plyr('.video-plyr .video-inner');

    const players = Plyr.setup('.video-plyr .video-inner', {
        captions: {active: false},
        controls: [],
        autoplay: true,
        muted: true,

    });
}

document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector('.video-plyr')) {
        plyrVideoInit();
        handleHomeHeroVimeo();
    }
});